// Affiliate System Constants

// Session
export const AFFILIATE_SESSION_COOKIE = 'affiliate_session';
export const AFFILIATE_SESSION_DURATION_HOURS = 24;

// Tracking
export const AFFILIATE_TRACKING_COOKIE = 'affiliate_ref';
export const AFFILIATE_TRACKING_DURATION_DAYS = 30;
export const AFFILIATE_VISITOR_COOKIE = 'affiliate_visitor';

// Security
export const MAX_FAILED_LOGIN_ATTEMPTS = 5;
export const LOCKOUT_DURATION_MINUTES = 15;

// Limits
export const MIN_PAYOUT_CENTS = 5000; // 50 EUR
export const MAX_LINKS_PER_AFFILIATE = 50;
export const LOCK_PERIOD_DAYS = 30; // Days before commission can be paid

// Default UTM values
export const DEFAULT_UTM_SOURCE = 'affiliate';
export const DEFAULT_LANDING_URL = '/';

// Affiliate types labels
export const AFFILIATE_TYPE_LABELS: Record<string, { es: string; en: string }> = {
    agency: { es: 'Agencia/Partner', en: 'Agency/Partner' },
    influencer: { es: 'Influencer', en: 'Influencer' },
    customer: { es: 'Cliente', en: 'Customer' },
    freelance: { es: 'Comercial freelance', en: 'Freelance sales' },
    marketplace: { es: 'Marketplace/Comparador', en: 'Marketplace/Comparator' },
};

// Status labels
export const AFFILIATE_STATUS_LABELS: Record<string, { es: string; en: string }> = {
    pending: { es: 'Pendiente', en: 'Pending' },
    approved: { es: 'Aprobado', en: 'Approved' },
    rejected: { es: 'Rechazado', en: 'Rejected' },
    suspended: { es: 'Suspendido', en: 'Suspended' },
};

// Commission status labels
export const COMMISSION_STATUS_LABELS: Record<string, { es: string; en: string }> = {
    pending: { es: 'Pendiente', en: 'Pending' },
    validated: { es: 'Validada', en: 'Validated' },
    paid: { es: 'Pagada', en: 'Paid' },
    rejected: { es: 'Rechazada', en: 'Rejected' },
};

// Payout status labels
export const PAYOUT_STATUS_LABELS: Record<string, { es: string; en: string }> = {
    pending: { es: 'Pendiente', en: 'Pending' },
    processing: { es: 'Procesando', en: 'Processing' },
    completed: { es: 'Completado', en: 'Completed' },
    failed: { es: 'Fallido', en: 'Failed' },
};

// Commission model labels
export const COMMISSION_MODEL_LABELS: Record<string, { es: string; en: string }> = {
    percentage: { es: 'Porcentaje', en: 'Percentage' },
    fixed: { es: 'Fijo', en: 'Fixed' },
    hybrid: { es: 'Híbrido', en: 'Hybrid' },
};

// Conversion event labels
export const CONVERSION_EVENT_LABELS: Record<string, { es: string; en: string }> = {
    registration: { es: 'Al registro', en: 'On registration' },
    first_payment: { es: 'Al primer pago', en: 'On first payment' },
    subscription_active: { es: 'Al activar suscripción', en: 'On subscription active' },
    hybrid: { es: 'Híbrido', en: 'Hybrid' },
};

// Payout method labels
export const PAYOUT_METHOD_LABELS: Record<string, { es: string; en: string }> = {
    bank_transfer: { es: 'Transferencia bancaria', en: 'Bank transfer' },
    paypal: { es: 'PayPal', en: 'PayPal' },
};

// Material type labels
export const MATERIAL_TYPE_LABELS: Record<string, { es: string; en: string }> = {
    banner: { es: 'Banner', en: 'Banner' },
    email_template: { es: 'Plantilla de email', en: 'Email template' },
    landing: { es: 'Landing page', en: 'Landing page' },
    video: { es: 'Video', en: 'Video' },
    document: { es: 'Documento', en: 'Document' },
    copy: { es: 'Texto/Copy', en: 'Copy text' },
};

// Countries list (subset for now)
export const COUNTRIES = [
    { code: 'ES', name: { es: 'España', en: 'Spain' } },
    { code: 'MX', name: { es: 'México', en: 'Mexico' } },
    { code: 'AR', name: { es: 'Argentina', en: 'Argentina' } },
    { code: 'CO', name: { es: 'Colombia', en: 'Colombia' } },
    { code: 'CL', name: { es: 'Chile', en: 'Chile' } },
    { code: 'PE', name: { es: 'Perú', en: 'Peru' } },
    { code: 'US', name: { es: 'Estados Unidos', en: 'United States' } },
    { code: 'GB', name: { es: 'Reino Unido', en: 'United Kingdom' } },
    { code: 'FR', name: { es: 'Francia', en: 'France' } },
    { code: 'DE', name: { es: 'Alemania', en: 'Germany' } },
    { code: 'IT', name: { es: 'Italia', en: 'Italy' } },
    { code: 'PT', name: { es: 'Portugal', en: 'Portugal' } },
];

// Timezones (subset)
export const TIMEZONES = [
    'Europe/Madrid',
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    'America/Mexico_City',
    'America/Buenos_Aires',
    'America/Bogota',
    'America/Santiago',
    'America/Lima',
    'America/New_York',
    'America/Los_Angeles',
];
